var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRateFill = function SvgRateFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.872.542l2.027 4.11c.14.286.415.485.73.53l4.536.66c.8.116 1.116 1.095.54 1.657l-3.282 3.2c-.23.223-.335.543-.28.86l.775 4.516c.134.794-.697 1.4-1.412 1.024l-4.055-2.13c-.285-.15-.623-.15-.906 0L4.492 17.1c-.713.375-1.548-.23-1.41-1.024l.773-4.516c.054-.317-.05-.637-.28-.86L.296 7.5c-.58-.563-.258-1.542.54-1.66l4.534-.658c.315-.045.59-.244.73-.53L8.127.54c.356-.722 1.388-.722 1.744 0",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgRateFill;